
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    players: Object
  },
  setup() {
    return {
    }
  }
});
